
import Injection = EECore.Injection;
import AdsSlideshow from "../../services/entities/ads/adsSlideshow";

class SlideshowState {
  container: Element;
  slides: Element[];
  progressElements: Element[];
  slideCount: number;
  currentIndex: number;
  playing: boolean;
  canResume: boolean;
  playInterval: number;
  playIntervalReference: number;
}

@Injection.injectableClass("AdsSlideshowBehavior")
export default class AdsSlideshowBehavior {

  @Injection.injectableProperty("AdsSlideshowBehavior", EECore.Registrations.HTML_HELPER)
  private htmlHelper: EECore.HtmlHelper;

  constructor(htmlHelper: EECore.HtmlHelper) {
    this.htmlHelper = htmlHelper;
  }

  apply(element: Element, parameters: AdsSlideshow): void {
    const slideContainer = element.querySelector(".slides");
    const progressContainer = element.querySelector(".progress");
    const controlsContainer = element.querySelector(".controls");
    const slides = slideContainer.querySelectorAll(".slide");
    const progressElements = progressContainer.children;

    const state: SlideshowState = {
      container: element,
      slides: Array.prototype.slice.call(slides),
      progressElements: Array.prototype.slice.call(progressElements),
      slideCount: slides.length,
      currentIndex: null,
      playing: false,
      canResume: false,
      playInterval: parameters.interval,
      playIntervalReference: null
    };

    this.setActive(state, 0);

    const me = this;
    const playButton = controlsContainer.querySelector("[data-action=play]");
    playButton.addEventListener("click", () => {
      me.start(state);
    });

    const pauseButton = controlsContainer.querySelector("[data-action=pause]");
    pauseButton.addEventListener("click", () => {
      me.stop(state);
    });

    const previousButton = controlsContainer.querySelector("[data-action=previous]");
    previousButton.addEventListener("click", () => {
      me.pause(state);
      me.setActive(state, state.currentIndex - 1);
      me.resume(state);
    });

    const nextButton = controlsContainer.querySelector("[data-action=next]");
    nextButton.addEventListener("click", () => {
      me.pause(state);
      me.setActive(state, state.currentIndex + 1);
      me.resume(state);
    });

    for (let i = 0; i < progressElements.length; i++) {
      this.applyProgressBehavior(progressElements[i], state);
    }

    if (parameters.autoPlay) this.start(state);
  }

  private applyProgressBehavior(progressElement: Element, state: SlideshowState) {
    const progressIndex = parseInt(progressElement.getAttribute("data-index"));
    const me = this;
    progressElement.addEventListener("click", () => {
      me.pause(state);
      me.setActive(state, progressIndex);
      me.resume(state);
    });
  }

  private start(state: SlideshowState) {
    if (!state.playing) {
      const me = this;
      state.playing = true;
      this.htmlHelper.addCssClass(state.container, "playing");
      state.playIntervalReference = window.setInterval(() => {
        me.setActive(state, state.currentIndex + 1);
      }, state.playInterval);
    }
  }

  private stop(state: SlideshowState) {
    if (state.playing) {
      state.playing = false;
      this.htmlHelper.removeCssClass(state.container, "playing");
      window.clearInterval(state.playIntervalReference);
    }
  }

  private pause(state: SlideshowState) {
    state.canResume = state.playing;
    this.stop(state);
  }

  private resume(state: SlideshowState) {
    if (state.canResume) {
      this.start(state);
      state.canResume = false;
    }
  }

  private setActive(state: SlideshowState, newIndex: number) {
    while (newIndex < 0) newIndex += state.slideCount;
    newIndex = newIndex % state.slideCount;

    if (newIndex !== state.currentIndex) {
      if (state.currentIndex != null) {
        this.htmlHelper.removeCssClass(state.slides[state.currentIndex], "active");
        this.htmlHelper.removeCssClass(state.progressElements[state.currentIndex], "active");
      }

      this.htmlHelper.addCssClass(state.slides[newIndex], "active");
      this.htmlHelper.addCssClass(state.progressElements[newIndex], "active");
      state.currentIndex = newIndex;
    }
  }

}